
<div tabindex="0"
     :data-id="objectModelProperty.client_id"
     :data-type="objectModelProperty.property_type"
     class="form-element object-model-property"
     :class="propertyClasses"
     v-on:focus="replaceIdInRoute($event, true)"
     @click.stop="replaceIdInRoute">
  <div class="title-bar">
    <icon :class="ObjectModelPropertyDefinition.getIcon(objectModelProperty.property_type)">
      <span class="sr-only">Focused Element: {{ObjectModelPropertyDefinition.getDisplayName(objectModelProperty.property_type)}}</span>
    </icon>
    <strong>
      {{ObjectModelPropertyDefinition.getDisplayName(objectModelProperty.property_type)}}
      <debug-sort-order :sortable="objectModelProperty"/>
    </strong>
    <move-destroy :card="objectModelProperty" @remove:card="confirmDelete" class="suffix"></move-destroy>
  </div>
  <row>
    <column class="row-title" v-if="objectModelProperty.can(ObjectModelPropertyCapability.labelable)">
      <div :id="`scroll-to-label-${objectModelProperty.client_id}`"/>
      <object-model-property-labelable
        :object-model-property="objectModelProperty"
      ></object-model-property-labelable>
    </column>
  </row>

  <component
    :is="getComponentByType(objectModelProperty.property_type)"
    :object-model-property="objectModelProperty"
    @remove="remove"
  >
    <row>
      <column>
        <p class="small">
          <lengthable-display v-if="objectModelProperty.canHaveCharacterCount"
                              :model="objectModelProperty"></lengthable-display>
          <numeric-min-maxable-display v-if="objectModelProperty.hasMinOrMaxValue"
                                       :model="objectModelProperty"></numeric-min-maxable-display>
          <date-min-maxable-display v-if="objectModelProperty.hasDateMinOrMaxValue"
                                    :model="objectModelProperty"></date-min-maxable-display>
        </p>
      </column>
      <column class="align-right">
        <p class="small element-details">
          <formattable-display v-if="objectModelProperty.hasFormat"
                               :model="objectModelProperty"></formattable-display>
          <indexable-display v-if="objectModelProperty.isIndexed" :model="objectModelProperty"></indexable-display>
          <template v-if="objectModelProperty.hasLinkedRelation">
            <linked-relationable-display :model="objectModelProperty"></linked-relationable-display>
            <linked-relation-propertyable-display
              v-if="objectModelProperty.hasLinkedRelation &&
               objectModelProperty.can(ObjectModelPropertyCapability.linkToRelationPropertyable) &&
               objectModelProperty.aggregate_type !== AggregateType.Count"
              :model="objectModelProperty"></linked-relation-propertyable-display>
          </template>
          <aggregatable-display
            v-if="objectModelProperty.canAggregate"
            :model="objectModelProperty"
            show-fallback
          ></aggregatable-display>

          <sensitive-data-icon v-if="propertyIsSecurityTagged" class="pl-1"></sensitive-data-icon>
        </p>
      </column>
    </row>
  </component>

  <modal :state="modalStateFor(vueModalID.confirmDeleteObjectModelProperty)"
         :index="vueModalID.confirmDeleteObjectModelProperty"
         @toggle-modal="hideModal(vueModalID.confirmDeleteObjectModelProperty)"
         v-if="modalStateFor(vueModalID.confirmDeleteObjectModelProperty).isVisible">
    <div slot="body">
      <h3 class="modal-title">Are You Sure?</h3>
      <p>Deleting {{objectModelProperty.labelTitleDisplay}}
        will make the property in ALL views and related items invalid. Are you sure you want to proceed?</p>
      <div class="cta">
        <button type="button" @click="hideModal(vueModalID.confirmDeleteObjectModelProperty)" class="btn block red outline">Cancel</button>
        <button type="button" @click="remove(objectModelProperty)" class="btn block green" data-action="affirm">Delete</button>
      </div>
    </div>
  </modal>
</div>
